import { useLocation, useNavigate } from 'react-router-dom';

export default function VerifyPending() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || 'tu email';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center p-8 bg-white rounded-2xl shadow-md max-w-md w-full">
        <div className="text-5xl mb-4">📧</div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Revisa tu email</h2>
        <p className="text-gray-600 mb-2">
          Hemos enviado un enlace de verificación a:
        </p>
        <p className="font-semibold text-gray-800 mb-6">{email}</p>
        <p className="text-gray-500 text-sm mb-6">
          Haz clic en el enlace del email para activar tu cuenta. 
          Revisa también la carpeta de spam.
        </p>
        <button
          onClick={() => navigate('/login')}
          className="text-indigo-500 hover:text-indigo-600 text-sm font-medium"
        >
          Volver al login
        </button>
      </div>
    </div>
  );
}
